import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    Image,
    Text,
    TouchableOpacity
} from 'react-native-web';

import GLOBAL from '../configs/config_global';

class CollapsibleView extends Component {
    static propTypes = {
        title: PropTypes.string,
        collapsedHeight: PropTypes.number,
        duration: PropTypes.number,
        style: PropTypes.object,
        showDivider: PropTypes.bool,
        renderTitleView: PropTypes.func,
        titleViewProps: PropTypes.object,
        contentStyle: PropTypes.object,
        expandInitially: PropTypes.bool,
        disabled: PropTypes.bool
    };

    static defaultProps = {
        title: 'Collapsible View Title',
        collapsedHeight: 0,
        duration: 250,
        style: {},
        showDivider: true,
        renderTitleView: null,
        titleViewProps: {},
        contentStyle: {},
        expandInitially: false,
        disabled: false
    };

    // region Constructor
    constructor(props) {
        super(props);
        this.state = {
            isCollapsed: !props.expandInitially,
        };
    }

    // region Function - Collapse
    collapseView() {
        this.setState({ isCollapsed: true });
    }
    // endregion

    // region Function - Expand
    expandView() {
        this.setState({ isCollapsed: false });
    }
    // endregion

    // region Render Title
    renderTitleView() {
        const MyView = this.props.disabled ? View : TouchableOpacity;

        return(
            <MyView onPress={!this.state.isCollapsed ? () => this.collapseView() : () => this.expandView()}>
                {
                    this.props.renderTitleView ?
                        this.props.renderTitleView(this.props.title, this.state.isCollapsed, this.props.titleViewProps)
                        :
                        <View style={{ alignSelf: 'stretch', flexDirection: 'row', alignItems: 'center', paddingTop: 16 }}>
                            {/* Text */}
                            <Text style={{ flex: 1, color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontSize: 20, lineHeight: 32 }}>
                                {this.props.title}
                            </Text>

                            {/* Expand Icon */}
                            <Image
                                source={this.state.isCollapsed ? require('../images/plus.png') : require('../images/minus.png')}
                                style={{ marginLeft: 6, width: 24, height: 24, tintColor: this.state.isCollapsed ? GLOBAL.COLOR.BASIC.PINKISH_GREY : GLOBAL.COLOR.MAIN }}
                                resizeMode={'stretch'}
                            />
                        </View>
                }
            </MyView>
        );
    }
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        return(
            <View style={[this.props.style, { alignSelf: 'stretch' }, this.props.showDivider && { borderBottomWidth: 1, borderColor: 'rgba(0, 0, 0, 0.05)' }]}>
                {/* Title */}
                {this.renderTitleView()}

                {/* Body */}
                <View style={[{ alignSelf: 'stretch', marginTop: 8, marginBottom: this.state.isCollapsed ? 8 : 16, overflow: 'hidden' }, this.props.contentStyle, { height: this.state.isCollapsed ? 0 : undefined }]}>
                    {this.props.children}
                </View>
            </View>
        );
    }
    // endregion
}

export default CollapsibleView;
